export enum TrackingEvents {
    FEATUREAPP_LOAD = 'VWBasic_GenericFeatureApp_Load',
    MODELSELECT_CLICK = 'VWBasic_ModelSelect_Click',
    VEHICLEBUTTON_CLICK = 'VWBasic_VehicleButton_Click',
    BUTTON_CLICK = 'VWBasic_Button_Click',
}
